import axios from "axios";

const getQr = () => axios.get("/personal/api/v1/tg/qr", {responseType: 'arraybuffer'});

const getQrWithHttpLink = () => axios.get("/personal/api/v1/tg/qr_tme", {responseType: 'arraybuffer'});

const getLink = () => axios.get(`/personal/api/v1/tg/link`);

const sendCode = () => axios.put(`/personal/api/v1/tg/send_code`);

const verifyCode = (code) => axios.put(`/personal/api/v1/tg/verify_code`, {code});

const getContact = () => axios.get(`/personal/api/v1/tg/contact`);

const unsubscribe = () => axios.put(`/personal/api/v1/tg/unsubscribe`);

export default {
    getQr,
    getLink,
    sendCode,
    verifyCode,
    getContact,
    unsubscribe,
    getQrWithHttpLink
}